import BaseAPI from 'api/api'
import { FindAllInterface } from 'api/api-interface'
/** UTIILS */

export interface TreatmentCourseTypeInterface {
  treatmentCourseTypeId?: number
  treatmentCourseTypeName: string
  treatmentCourseTypeNameEn?: string
  status: string
}

export default class TreatmentCourseTypeApi extends BaseAPI {
  static findAll(props: FindAllInterface): Promise<any> {
    return this.api.get('treatment-course-types', { params: { ...props } }).then((res) => res)
  }

  static create(playload: any) {
    return this.api.post('treatment-course-types', playload)
  }

  static findById(id: number): Promise<TreatmentCourseTypeInterface> {
    return this.api.get(`treatment-course-types/${id}`)
  }

  static update(id: number, body: TreatmentCourseTypeInterface) {
    return this.api.patch(`treatment-course-types/${id}`, body)
  }

  static updateStatus(id: number, status: string): Promise<any> {
    return this.api.patch(`treatment-course-types/${id}/status`, { id, status })
  }

  static remove(id: number) {
    return this.api.delete(`treatment-course-types/${id}`)
  }
}
